import { LineChart } from '@mui/x-charts/LineChart';

function Line2() {
    return (
        <LineChart
            xAxis={[{ 
                data: [1, 2, 3, 5, 8, 10],
                tickLabelStyle: { fill: 'white' },
            }]}
            series={[
                {
                data: [2, 5.5, 2, 8.5, 1.5, 5],
                area: true,
                },
            ]}
            height={300}
            borderRadius={10}
            margin={{ left: 0, right : 5, top:0, bottom : 0 }}
            yAxis={[
                {
                width: 20,
                tickLabelStyle: { fill: 'white' },
                },
            ]}
        />
    )
}

export default Line2